export const apiBaseURL = process.env.NODE_ENV === 'development'
    ? 'http://127.0.0.1:8000'
    : process.env.REACT_APP_BACKEND_URL